import jws from "jws";
import { get } from "lodash";
import appConfig, {channelEnum} from "../appconfig";
import * as mutationTypes from "../store/mutation-types";
import getPkce from "oauth-pkce";
import AppUsersProvider from "../providers/AppUsersProvider";
import PersonServiceProvider from "../providers/idp/PersonServiceProvider";
import LoggerProvider from "../providers/LoggerProvider";
import ServerLogProvider from "../providers/ServerLogProvider";
import {getPersonId} from "../domains2/libraries/Utils";
import { updateDeliveryAddressFromPersonService } from "../helper/DeliveryMethodsHelper";
import { checkCapacitorPushPermissions, registerCapacitorPushNotifications} from "./CapacitorPushNotificationsHelper";
// import { isMobileChannel } from "../libraries/utils";

const tenantConfig = appConfig.tenantConfig;

export const getPersonFromJwt = (personIdpToken) => {
	if(personIdpToken) {
		try {
			const res = jws.decode(personIdpToken);
			return res.payload;
		} catch (e) {
			return {};
		}
	}
	return {};
};

export const logOutFromIdp = async (idpService, isMobile, baseUrl, router, store, tenantId = null) => {
	const { managementApi, provider, clientId } = idpService;
	switch(provider){
	case "Auth0":
	{
		const idpLink = `https://${managementApi.domain}/v2/logout?client_id=${clientId}&returnTo=${encodeURIComponent(baseUrl)}`;
		LoggerProvider.logEvent({
			message: `Sunset-logging out from idp`,
			eventName: "LogOut",
			eventCategory: "LogOut",
			eventDomain: "UserAuth",
			data: {
				idpLink
			}
		});

		if(isMobile) {
			const loginRef = window.open(
				idpLink,
				"_blank",
				"location=no,toolbar=no,zoom=no,closebuttoncaption=''"
			);

			loginRef.addEventListener("loadstart", event => {
				if (event.url.startsWith(baseUrl)) {
					router.push(event.url.replace(baseUrl, ""));
					loginRef.close();
				}
			});
		} else {
			store.commit(mutationTypes.REMOVE_USER_IDP_TOKEN);
			await store.dispatch(mutationTypes.PERSON_DATA_CLEAR);
			await store.dispatch(mutationTypes.REMOVE_USER_DATA);
			window.open(idpLink, "_self");
		}
		break;
	}
	case "SprintingIdp":
	{
		// const idpLink = `${managementApi.domain}/logout?client_id=${clientId}&returnTo=${encodeURIComponent(baseUrl)}`;

		LoggerProvider.logEvent({
			message: `Sunset-logging out from Sprinting Idp`,
			eventName: "LogOut",
			eventCategory: "LogOut",
			eventDomain: "UserAuth",
			data: {
			}
		});
		await AppUsersProvider.logOutUser(store.getters.applicationUserIdpToken, tenantId);
		store.commit(mutationTypes.REMOVE_USER_IDP_TOKEN);
		await store.dispatch(mutationTypes.PERSON_DATA_CLEAR);
		await store.dispatch(mutationTypes.GATHER_EVALUATION_TAG_DATA);
		await store.dispatch(mutationTypes.REMOVE_USER_DATA);
		await store.dispatch(mutationTypes.RECALCULATE_SUBSCRIPTION_SET_CART_ORDER_TAGS);
		await store.dispatch(mutationTypes.PURGE_CART);
		await router.push({ name: "Home" });
		// if(isMobile) {
		// 	const loginRef = window.open(
		// 		idpLink,
		// 		"_blank",
		// 		"location=no,toolbar=no,zoom=no,closebuttoncaption=''"
		// 	);
		//
		// 	loginRef.addEventListener("loadstart", event => {
		// 		if (event.url.startsWith(baseUrl)) {
		// 			router.push(event.url.replace(baseUrl, ""));
		// 			loginRef.close();
		// 		}
		// 	});
		// } else {
		// 	store.commit(mutationTypes.REMOVE_USER_IDP_TOKEN);
		// }
		break;
	}
	default: {
		break;
	}
	}
};
export const getIdpLink = async (idpService, baseUrl, userEmailForm, userExists, returnUrl, emailChange, store, updatePassword) => {
	const { authUrl, provider } = idpService;
	const languageCode = store.getters.lastLocale;

	switch(provider){
	case "SprintingIdp":
		return getSprintingIdpPkceLink(idpService, baseUrl, userEmailForm, userExists, returnUrl, emailChange, languageCode, updatePassword);
	case "Auth0":
	{
		return getAuth0PkceLink(idpService, baseUrl, userEmailForm, userExists, returnUrl);
	}
	case "Gigya":
	{
		const return_url = encodeURIComponent(baseUrl);
		// if(productionEnvs.includes(appConfig.envPrefix())) {
		// 	return `https://p-idp.dsgapps.dk/apps?clientId=bifrost&tenantId=6&channel=CustomerProgram&clientFlow=gigya&nonce=none&clientTraceId=${appConfig.clientTraceId()}&emailOrPhone=${encodeURIComponent(self.userEmailForm.value)}&redirect_uri=${return_url}`;
		// } else {
		// 	return `https://t-idp.dsgapps.dk/apps?clientId=bifrost&tenantId=6&channel=CustomerProgram&clientFlow=gigya&nonce=none&clientTraceId=${appConfig.clientTraceId()}&emailOrPhone=${encodeURIComponent(self.userEmailForm.value)}&redirect_uri=${return_url}`;
		// }
		return `${authUrl}clientId=bifrost&tenantId=6&channel=CustomerProgram&clientFlow=gigya&nonce=none&clientTraceId=${appConfig.clientTraceId()}&emailOrPhone=${encodeURIComponent(userEmailForm.value)}&redirect_uri=${return_url}`;
	}
	}
};
const getSprintingIdpPkceLink = async (idpService, baseUrl, userEmailForm, userExists = false, returnUrl, emailChange, languageCode, updatePassword) => {
	const {authUrl, clientId, managementApi} = idpService;
	const {verifier, challenge} = await new Promise((resolve) => {
		getPkce(43, (error, {verifier, challenge}) => {
			if (error) {
				throw error;
			}
			resolve({verifier, challenge});
		});
	});
	const urlToEncode = returnUrl || baseUrl;
	const hookUrl = ((currentUrl, hookUrl) => {
		if(/^https?:\/\//i.test(hookUrl)) {
			return encodeURIComponent(hookUrl);
		}

		const regexReplace = hookUrl.startsWith("/") ? hookUrl : `/${hookUrl}`;
		return encodeURIComponent(currentUrl.replace(/\/?$/, regexReplace));
	})(baseUrl, managementApi.hookUrl);
	const return_url = encodeURIComponent(urlToEncode.replace(/\/?$/, ""));
	// store verifier so we can verify when we are redirected back
	localStorage.setItem("appUserCodeVerifier", verifier);
	const code_challenge = challenge;//Utils.PKCE.challenge(verifier);
	const [tenantAlias] = new URL(authUrl).pathname.split("/").filter(Boolean);
	const state = jws.sign({
		payload: { email: userEmailForm.value, personData: userEmailForm.personData },
		header: {
			alg: managementApi.signAlg
		},
		secret: managementApi.signSecret
	});
	const startScreen = determineStartScreen(userExists, emailChange, updatePassword);
	const queryParams = {
		response_type: "code",
		code_challenge,
		code_challenge_method: "S256",
		client_id: clientId,
		redirect_uri: return_url,
		prompt: encodeURI("login consent"),
		// refresh token works ONLY if we have offline_access
		scope: encodeURI("openid profile offline_access"),
		start_screen: startScreen,
		tenant_alias: tenantAlias,
		state,
		hook_uri: hookUrl,
		flow: "unified",
		language_code: languageCode
	};

	const query = Object.entries(queryParams).map(([key, value]) => `${key}=${value}`).join("&");
	return `${authUrl}${query}`;
};

const determineStartScreen = (userExists, emailChange, updatePassword) => {
	if(updatePassword) {
		return "update-password";
	}
	if(emailChange) {
		return "change-email";
	}
	return userExists ? "login" : "register";
};

export const getAuth0PkceLink = async (idpService, baseUrl, userEmailForm, userExists = false, returnUrl) => {
	const {authUrl, clientId} = idpService;
	const {verifier, challenge} = await new Promise((resolve) => {
		getPkce(43, (error, {verifier, challenge}) => {
			if (error) {
				throw error;
			}
			resolve({verifier, challenge});
		});
	});
	const return_url = encodeURIComponent(returnUrl) || encodeURIComponent(baseUrl);
	// store verifier so we can verify when we are redirected back
	localStorage.setItem("appUserCodeVerifier", verifier);
	const code_challenge = challenge;//Utils.PKCE.challenge(verifier);
	const queryParams = {
		response_type: "code",
		code_challenge,
		code_challenge_method: "S256",
		client_id: clientId,
		redirect_uri: return_url,
		scope: encodeURI("openid profile"),
		state: "xyzABC123",
		screen_hint: userExists ? "login" : "signup",
		login_hint: userEmailForm.value
	};

	const query = Object.entries(queryParams).map(([key, value]) => `${key}=${value}`).join("&");
	return `${authUrl}${query}`;
};
export const redirectToIdp = async (event, idpService, isMobile, baseUrl, userEmailForm, userExists, returnUrl, store, emailChange = false, updatePassword = false) => {
	if (event) {
		event.preventDefault();
	}
	const idpLink = await getIdpLink(idpService, baseUrl, userEmailForm, userExists, returnUrl, emailChange, store, updatePassword);

	if (isMobile) {
		const browserObjectModel = window.cordova ? window.cordova.InAppBrowser : window;
		const loginRef = browserObjectModel.open(
			idpLink,
			"_blank",
			"location=no,toolbar=no,zoom=no,closebuttoncaption=''"
		);
		let router = null;
		const routerPromise = import("../router")
			.then(({ router: routerFetched }) => {
				router = routerFetched;
			});

		loginRef.addEventListener("loadstart", async (event) => {
			if (event.url.startsWith(baseUrl)) {
				const path = event.url.replace(baseUrl, "");
				router.push(path);
				loginRef.close();
				const {pushNotificationsGranted, fcmToken, deviceInfo: {androidSDKVersion}} = store.getters;
				const platform = appConfig.mobile.mobileApi().platformId;
				setTimeout(async () => {
					if (!pushNotificationsGranted && fcmToken) {
						if (platform === "ios" || (platform === "android" && androidSDKVersion >= 33)) {
							const permStatus = await checkCapacitorPushPermissions();
							if (permStatus === "granted") {
								await registerCapacitorPushNotifications();
							}
						}
						if (platform === "android" && androidSDKVersion <= 33) {
							await registerCapacitorPushNotifications();
						}
					}
				}, 100);
			}
		});
		await routerPromise;
	} else {
		window.open(idpLink, "_self");
	}

	// if (isMobileChannel() && store.getters.featureToggles.moveRestaurantAndDeliveryMethodToAppInitiation && !localStorage.getItem("redirect")) {
	// 	localStorage.setItem("redirect", "/shop-selection");
	// }
};

export const logOutAuth0ConcreteImpl = (event, idpService, router, store, tenantId = null) => {
	if(event) {
		event.preventDefault();
	}
	const isMobile = appConfig.mobile.isMobileApp();
	const baseUrl = isMobile ? appConfig.getBaseUrl() : window.location.origin;
	logOutFromIdp(idpService, isMobile, baseUrl, router, store, tenantId);
};

export const getAuth0IdFromSub = (sub, idpService) => getPersonId(sub, idpService.provider);

const registerAppUser = async (jwtToken, store, callback) => {
	const {deviceData} = store.getters;
	const {userCvrNumber} = store.getters;
	const channel = appConfig.channelAlias();

	const response = await AppUsersProvider.registerUser({
		idpToken: jwtToken,
		payload: {
			deviceData,
			channel,
			userCvrNumber
		}
	})
		.catch(error=>{
			return (async ()=>{
				const e = error.response.data;
				const {maximumDevices} = await store.dispatch(mutationTypes.MAXIMUM_NUMBER_OF_DEVICES_REACHING);
				const {activeSessions} = e.data || e.contextData; // activeSessions will be sent as part of error response data

				if([e.errorCode, e.errorName].includes("MaximumNumberOfAllowedDevicesExceeded")){

					store.commit(mutationTypes.SET_FRAUD_PROTECTION, {
						modalVisible: true,
						activeSessionsNumber: maximumDevices,
						maximumDevicesNumber: maximumDevices,
						messageType: "maximumNumberOfDevicesExceeded",
						activeSessions
					});
				}
				return e.errorCode;
			})();
		});
	if(response && response.data && response.data.success) {
		store.commit(mutationTypes.FIRST_LOGIN_SET, response.data.firstLogin);
		LoggerProvider.logEvent({
			message: `User added to app users table`,
			eventName: "AppUsers",
			eventCategory: "AppUsers",
			eventDomain: "UserAuth",
			data: {
				responseData: response.data
			}
		});
		store.commit(mutationTypes.SET_USER_IDP_TOKEN, jwtToken);
		callback(response);
	} else if(response === "MaximumNumberOfAllowedDevicesExceeded"){
		callback(response);
	}
	else {
		ServerLogProvider.postErrorToServer({msg: `User is probably not added to app users table. Check it out.`});
		callback(response);
	}
	return response;
};

const prepareAuth0Details = (clientId, code, verifier, baseUrl, grantType="authorization_code") => {
	const details = {
		grant_type: grantType,
		client_id: clientId,
		code_verifier: verifier,
		code: code,
		redirect_uri: baseUrl
	};
	let formBody = [];
	for (const property in details) {
		const encodedKey = encodeURIComponent(property);
		const encodedValue = encodeURIComponent(details[property]);
		formBody.push(encodedKey + "=" + encodedValue);
	}
	formBody = formBody.join("&");
	return formBody;
};

const prepareRefreshTokenDetails = (provider, clientId, refreshToken) => {
	const details = {
		grant_type: "refresh_token",
		client_id: clientId,
		refresh_token: refreshToken
	};
	let formBody = [];
	for (const property in details) {
		const encodedKey = encodeURIComponent(property);
		const encodedValue = encodeURIComponent(details[property]);
		formBody.push(encodedKey + "=" + encodedValue);
	}
	formBody = formBody.join("&");
	return formBody;
};

const getPersonDataAndStore = async (store, personId, id_token, retryNumber = 0) => {
	const personExistsResponse = await PersonServiceProvider
		.getPersonData(tenantConfig.tenantId, personId, id_token)
		.catch(() => null);
	if (get(personExistsResponse, "data.person.success", false)) {
		const personDataStored = personExistsResponse.data.person.data;
		await store.dispatch(mutationTypes.PERSON_DATA_SET, personDataStored.data);
		await updateDeliveryAddressFromPersonService(store);
		return;
	}

	// if it fails after minute, it probably did not create properly
	if (retryNumber >= 40) {
		return Promise.reject("Failed to get Person data");
	}
	await new Promise((resolve) => setTimeout(resolve, 1500));
	return getPersonDataAndStore(store, personId, id_token, retryNumber + 1);
};

export const refreshUserToken = async (refreshToken, idpService) => {
	const { clientId, authServer, provider } = idpService;
	const formBody = prepareRefreshTokenDetails(provider, clientId, refreshToken);
	const authServiceResponsePromise = await fetch(authServer, {
		method: "POST",
		headers: {
			"content-type": "application/x-www-form-urlencoded"
		},
		body: formBody
	});
	return authServiceResponsePromise.json();
};

const getUserInfoOrRefreshToken = async (store, shouldGatherUserData) => {
	if (store.getters.applicationUserIdpToken) {
		const { exp } = getPersonFromJwt(store.getters.applicationUserIdpToken);
		if (exp) {
			const expectedTimeBeforeRefresh = 15 * 60 * 1000; // refresh should happen 15 minutes before token expires
			const timeBeforeExpiration = exp * 1000 - Date.now();
			if (timeBeforeExpiration < expectedTimeBeforeRefresh) {
				await store.dispatch(mutationTypes.RESET_USER_ACCESS_TOKEN_USING_REFRESH_TOKEN);
				if (shouldGatherUserData) {
					await store.dispatch(mutationTypes.GATHER_USER_DATA);
				}
			} else if (shouldGatherUserData) {
				await store.dispatch(mutationTypes.GATHER_USER_DATA);
			}
		}
	}
};

export const checkIfUserLoggedIn = async ({
	route, store, idpService, router = null,
	registerAppUserCallback = () => {},
	additionalConfigurationCallback = () => {},
	afterSuccessfulLoginCallback = async () => {}
}) => {
	const verifyPersistedCardDetails = () => {
		const { customerDetails, recurringPaymentDetails } = store.getters;

		// for billwerk to persist payment details, the customer handle and externalIdpId has to be the same
		// else it means that the customer is not the same
		if ((customerDetails || {}).id !== (recurringPaymentDetails || {}).customerReference) {
			store.commit(mutationTypes.SET_RECURRING_PAYMENT_DETAILS, {});
		}
	};

	if(route.fullPath.includes("id_token")) {
		const frontIndex = route.fullPath.indexOf("=") + 1;
		const additionalParamIndex = route.fullPath.indexOf("&");
		const backIndex = additionalParamIndex !== -1 ? additionalParamIndex : route.fullPath.length;
		const jwtToken = route.fullPath.substring(frontIndex, backIndex);

		await registerAppUser(jwtToken, store, registerAppUserCallback);
		if (store.getters.featureToggles.enableSubscription || store.getters.featureToggles.enableSunsetPoints) {
			await store.dispatch(mutationTypes.GATHER_USER_DATA);
		}
		verifyPersistedCardDetails();
	} else if(route.query && route.query.code) {
		// query param 'code' exits in route but it was already verified if userIdpTokenExits so
		// there is no need for reaction on this
		if(store.getters.applicationUserIdpToken && store.getters.idpAction !== "ChangeEmail"){
			await getUserInfoOrRefreshToken(store, true);
			// It is needed for supporting the scenario when user changes password and logging out on all his devices
			await AppUsersProvider.logOutUserAllDevices(store.getters.applicationUserIdpToken);
			store.commit(mutationTypes.REMOVE_USER_IDP_TOKEN);
			await store.dispatch(mutationTypes.PERSON_DATA_CLEAR);
			await store.dispatch(mutationTypes.GATHER_EVALUATION_TAG_DATA);
			await store.dispatch(mutationTypes.REMOVE_USER_DATA);
			verifyPersistedCardDetails();
			if (router) {
				router.replace("/");
				await router.push({ name: "Home" });
			}
		} else {
			const isMobile = appConfig.mobile.isMobileApp();
			const path = route.path === "/" ? "" : route.path;
			const origin = isMobile ? appConfig.getBaseUrl() + path : window.location.origin + path;
			const baseUrl = route.query.flow ? `${origin}?flow=${route.query.flow}` : origin;
			const { clientId, authServer } = idpService;
			const verifier = localStorage.getItem("appUserCodeVerifier");
			const formBody = prepareAuth0Details(clientId, route.query.code, verifier, baseUrl, "authorization_code");

			try{
				const authServiceResponsePromise = await fetch(authServer, {
					method: "POST",
					headers: {
						"content-type": "application/x-www-form-urlencoded"
					},
					body: formBody
				});
				const authServiceResponse = await authServiceResponsePromise.text();
				const parsedRes = JSON.parse(authServiceResponse);
				const {id_token, refresh_token} = parsedRes;
				if(id_token){
					localStorage.removeItem(verifier);
					store.commit(mutationTypes.SET_USER_REFRESH_TOKEN, refresh_token);
					// TODO: Fix this - rename registerAppUser to sth more meaningfull
					const appUserRegisteredResponse = await registerAppUser(id_token, store, registerAppUserCallback);
					if (appUserRegisteredResponse && appUserRegisteredResponse.data && appUserRegisteredResponse.data.success) {
						const decodedIdToken = jws.decode(id_token);
						const auth0Id = decodedIdToken.payload.sub;

						try{
							await getPersonDataAndStore(store, getAuth0IdFromSub(auth0Id, idpService), id_token);
							// eslint-disable-next-line no-unused-vars
							const { code, state, ...query } = route.query;
							await store.dispatch(mutationTypes.GATHER_USER_DATA);
							await afterSuccessfulLoginCallback();

							if (router) {
								router.push({
									query,
									path: route.path
								});
							}
						} catch(e){
							ServerLogProvider.postErrorToServer(e);
						}
					}
				}
			} catch(e){
				// eslint-disable-next-line no-console
				console.log("error::", e);
			} finally {
				verifyPersistedCardDetails();
			}
			store.commit(mutationTypes.SET_IDP_ACTION, "");
		}
	} else {
		await getUserInfoOrRefreshToken(store);
	}
	await additionalConfigurationCallback();
	if(router && localStorage.getItem("redirect")) {
		if(channelEnum.desktopBrowser === localStorage.getItem("channel")) {
			store.getters.featureToggles.checkoutOnSinglePage ? store.commit(mutationTypes.CART_SUBMIT_USER_DATA) : store.commit(mutationTypes.CART_INCREASE_STEP_GT3);
		} else {
			store.getters.featureToggles.checkoutOnSinglePage ? store.commit(mutationTypes.CART_SUBMIT_USER_DATA) : store.dispatch(mutationTypes.CART_SUBMIT_USER_DATA);
		}
		store.dispatch(mutationTypes.RECALCULATE_SUBSCRIPTION_SET_CART_ORDER_TAGS);
		router.push(localStorage.getItem("redirect"));
		localStorage.removeItem("redirect");
	}
};

export async function checkGigyaUser(idpService, email) {
	if (!(appConfig.isBM6() && idpService.provider === "Gigya" && email)) {
		return false;
	}

	const { authUrl} = idpService;
	let idpServer = "";

	if(appConfig.envPrefix() === "a") {
		idpServer = "https://t-idp.dsgapps.dk";
	} else {
		idpServer = new URL(authUrl).origin;
	}

	const tenantId = 6;

	const idpCheckUrl = `${idpServer}/isNotGigyaUser?clientId=bifrost&tenantId=${tenantId}&channel=CustomerProgram&clientFlow=gigya&email=${email}`;

	try {
		const authServiceResponsePromise = await fetch(idpCheckUrl);
		const res = await authServiceResponsePromise.json();

		return !res.isNotGigyaUser;
	} catch (e) {} // eslint-disable-line no-empty
	// if something's wrong then return true
	return true;
}
